import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowBackIcon } from "../../../util/Icons";
import SubMenuWrapper, { SubMenuItem } from "../../../util/SubMenu";
import FiveKMenu from "./5kmenu";
import TrainingDaysSelector from "../../components/TrainingDaysSelector";
import TrainingPlanViewer from "../../components/TrainingPlanViewer";
import SixMinTestForm from "../../components/SixMinTestForm";

export default function FiveKPlan() {
    const [showTest, setShowTest] = React.useState(false);

    useEffect(() => {
        document.title = "5K Training Plan - MCC";
    }, []);
    return (
        <div className="min-h-screen py-8 md:px-4" style={{ background: '#ffffff' }}>
            <div className="max-w-4xl mx-auto">
                {/* SubMenu */}
                <SubMenuWrapper>
                    <SubMenuItem icon={<ArrowBackIcon size={24} color="#6b7280" />} label={"Training Plans"} to={"/training-plans"} />
                </SubMenuWrapper>

                {/* Hero Section */}
                <div className="text-center mb-6 mt-4">
                    <span className="inline-block px-4 py-1 rounded-full text-sm font-medium mb-3" style={{
                        background: 'linear-gradient(90deg, #f97316 0%, #ea580c 100%)',
                        color: 'white'
                    }}>
                        🏃 Welcome
                    </span>
                    <h1 className="text-3xl md:text-4xl font-extrabold mb-3" style={{
                        background: 'linear-gradient(90deg, #1e293b 0%, #334155 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                    }}>
                        5K Training Plan
                    </h1>
                    <p className="text-base md:text-lg" style={{ color: '#64748b' }}>
                        Build your endurance and speed for your first or fastest 5K.
                    </p>
                </div>

                {/* Training Plan Content */}
                <div className="flex flex-col p-1 text-black  mx-auto space-y-4">

                    <FiveKMenu />

                    {/* Open 6-Minute Test modal */}
                    <div className="px-4">
                        <button
                            onClick={() => setShowTest(true)}
                            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                        >
                            6-Minute Test
                        </button>
                    </div>

                    <TrainingDaysSelector />
                    <TrainingPlanViewer />

                    {/* 6-Minute Test Modal */}
                    {showTest && (
                        <div
                            className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center"
                            onClick={() => setShowTest(false)}
                        >
                            <div
                                className="bg-white p-4 rounded-md m-4 relative max-w-md w-full max-h-[80vh] overflow-y-auto"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <button
                                    onClick={() => setShowTest(false)}
                                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
                                >
                                    Close
                                </button>

                                <SixMinTestForm />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
